// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highcharts-background{fill:transparent}.keyfigure-inner .sparkline{max-width:200px;height:64px;padding-top:6px}.highcharts-color-11{fill:#04f;stroke:#04f}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
